module.exports = __webpack_public_path__ + "static/cucina_low-254a8f4269db08f1d8de0fcaf9e7cb2a.mp4";